export default __webpack_public_path__ + "static/icons-bg-indigo-04827f299cae3f2a5322734d34ff399e.svg";